const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home'),
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('../views/NotFound'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Login'),
  },
  {
    path: '/shoppingCart',
    name: 'ShoppingCart',
    component: () => import('../views/ShoppingCart'),
  },
  {
    path: '/userInfo',
    name: 'UserInfo',
    component: () => import('../views/UserInfo'),
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/Search'),
  },
  {
    path: '/yourOrders',
    name: 'YourOrders',
    component: () => import('../views/YourOrders'),
  },
  {
    path: '/footPrint',
    name: 'FootPrint',
    component: () => import('../views/FootPrint'),
  },
  {
    path: '/detail',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail'),
  },
  {
    path: '/filterPage',
    name: 'FilterPage',
    component: () => import('../views/FilterPage'),
  },
  {
    path: '/wantlist',
    name: 'WantList',
    component: () => import('../views/WantList'),
  },
  {
    path: '/ordersDetails',
    name: 'OrderDetails',
    component: () => import('../views/OrderDetails'),
  },
  {
    path: '/updatePwd',
    name: 'UpdatePwd',
    component: () => import('../views/UpdatePwd'),
  },
  {
    path: '/orderConfirm',
    name: 'OrderConfirm',
    component: () => import('../views/OrderConfirm'),
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import('../views/Shop'),
  },
  {
    path: '/reviewManage',
    name: 'ReviewManage',
    component: () => import('../views/ReviewManage'),
  },
  {
    path: '/reviewDetails',
    name: 'ReviewDetails',
    component: () => import('../views/ReviewDetails'),
  },
  {
    path: '/notification',
    name: 'Notification',
    component: () => import('../views/Notification'),
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicy'),
  }
]

export default routes
